import { ClosingReason, Order } from "cw-backend";

export class OrderClosure {
    id: number;
    order: any;
    closingReason: any;
    description: string;
    date: string;
    hour: string;
}